export function ImandraXMonoMark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 1355 1356"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          d="M1011.73 1013.64L677.511 678.39L1.40585 1355.42L677.753 939.967L1011.73 1013.64Z"
          fill="currentColor"
        />
        <path
          d="M336.672 337.513L677.498 678.371L1353.61 0.84701L677.265 427.032L336.672 337.513Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
